<template>
  <div id="app">
    <!-- Header component -->
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <!-- Router outlet for different pages -->
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "App",
  components: {},
  setup() {
    onMounted(() => {
      // ✅ Create or update favicon dynamically
      const setFavicon = (url) => {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = url;
      };

      // ✅ Path to your favicon (make sure it's in /public folder)
      setFavicon("/mamabots-favicon.png");
    });
  },
});
</script>

<style>
/* Global styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
